import { SCENARIO } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(SCENARIO);
const actions = { ...rawActions, ...thunkFactory(SCENARIO, '/cenario/') };
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(SCENARIO, initialState);

// SAGAS
const sagas = sagasFactory(SCENARIO, '/cenario/');
export { sagas };

